import React, { CSSProperties } from "react";
import { IconType } from "react-icons";

interface TabStripTitleProps {
  title: string;
  icon?: IconType;
  iconStyle?: CSSProperties;
}
const TabStripTitle = ({
  title,
  icon: Icon,
  iconStyle,
}: TabStripTitleProps) => {
  return (
    <>
      {Icon && <Icon style={{ fontSize: "18", ...iconStyle }} />}
      <span style={{ fontWeight: "bold", marginLeft: Icon ? "5px" : "0px" }}>
        {title}
      </span>
    </>
  );
};

export default TabStripTitle;
